

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CdcFlowStateService {
  private active$ = new BehaviorSubject<boolean>(false);
  start() { this.active$.next(true); }
  end()   { this.active$.next(false); }
  isActive(): boolean { return this.active$.getValue(); }
}
